import HackTimer from '@byted-cg/worker-timer';
import { Subject } from '../events/Subject.js';
import { ContextClassBase } from '../service/RuntimeContext.js';

const { setIntervalWarp, clearIntervalWarp, setTimeoutWarp, clearTimeoutWarp } = HackTimer;
var TickerStatus;
(function (TickerStatus) {
    TickerStatus[TickerStatus["Stopped"] = 0] = "Stopped";
    TickerStatus[TickerStatus["Running"] = 1] = "Running";
})(TickerStatus || (TickerStatus = {}));
class Ticker extends ContextClassBase {
    constructor(ctx, refreshRate, doneDuration) {
        super(ctx);
        this.state = TickerStatus.Stopped;
        this.refreshRate = 0;
        this.doneDuration = 0;
        this.refreshRate = refreshRate;
        this.doneDuration = doneDuration;
        this.onTick = new Subject(this.ctx);
        this.onDone = new Subject(this.ctx);
        this.onStop = new Subject(this.ctx);
        return this;
    }
    get duration() {
        if (this.state === TickerStatus.Stopped && this.lastStopTime !== 0) {
            return this.lastStopTime - this.startTime;
        }
        if (this.state === TickerStatus.Running) {
            return Date.now() - this.startTime;
        }
        return 0;
    }
    start() {
        if (this.state !== TickerStatus.Running) {
            this.restart();
        }
    }
    restart() {
        if (this.tickTimer) {
            this.stop();
        }
        this.state = TickerStatus.Running;
        const { enableHackTimer } = this.ctx.option;
        const setIntervalProxy = enableHackTimer ? setIntervalWarp : setInterval;
        const setTimeoutProxy = enableHackTimer ? setTimeoutWarp : setTimeout;
        this.tickTimer = setIntervalProxy(() => {
            this.update();
        }, this.refreshRate);
        if (this.doneDuration !== undefined) {
            this.doneTimer = setTimeoutProxy(() => {
                this.done();
            }, this.doneDuration);
        }
        this.startTime = Date.now();
        this.lastStopTime = 0;
        this.update();
    }
    stop() {
        if (this.state === TickerStatus.Stopped) {
            return;
        }
        const { enableHackTimer } = this.ctx.option;
        const clearIntervalProxy = enableHackTimer ? clearIntervalWarp : clearInterval;
        const clearTimeoutProxy = enableHackTimer ? clearTimeoutWarp : clearTimeout;
        clearIntervalProxy(this.tickTimer);
        clearTimeoutProxy(this.doneTimer);
        this.state = TickerStatus.Stopped;
        this.lastStopTime = Date.now();
        this.onStop.nextEmpty();
    }
    getTickTimer() {
        return this.tickTimer;
    }
    update() {
        this.onTick.nextEmpty(this);
    }
    done() {
        this.stop();
        this.onDone.nextEmpty();
    }
}

export { Ticker, TickerStatus };
//# sourceMappingURL=ticker.js.map
